import axios from "axios";
import { HotelItineraryRequest, HotelItineraryResponse } from "redmond";
import { config } from "../../../api/config";
import { apiVersionPrefix } from "../../../api/v0/paths";

export type { HotelItineraryRequest, HotelItineraryResponse };

const hotelItineraryApiPath = `${apiVersionPrefix}/itinerary/hotel`;

// Hotel API returns HotelItineraryResponse directly (no wrapper, unlike flight API)
export const fetchHotelItineraries = async (
  req: HotelItineraryRequest
): Promise<HotelItineraryResponse> => {
  const res = await axios.put<HotelItineraryResponse>(hotelItineraryApiPath, req, {
    baseURL: config.baseURL,
  });
  return res.data;
};
